module.exports = __webpack_public_path__ + "img/loading.6fca17c.gif";